import * as React from "react";
import Modal from 'react-modal';
import { MainMenuItem } from "../interfaces/Menu";
import { Link, RouteComponentProps } from "react-router-dom";
import { AppContextProps, withAppContext } from "../context/AppContext";
import { findLastOfficeStatus } from "../services/Report";
import { ReportOfficeStatus } from "../interfaces/ReportOfficeStatus";
import { MESSAGE_WARNING } from "../const/Message";
import i18n from "../i18n";
import { DEVICES_BALANCE_STOCKTAKING_ROUTE, MAIN_ROUTE } from "../const/Routes";

interface MainMenuProps extends RouteComponentProps, AppContextProps {
    menuItems: MainMenuItem[]
 }
interface MainMenuState { 
    pendingModalIsOpen: boolean;
}

export class MainMenuMain extends React.Component<MainMenuProps, MainMenuState> {
    constructor(props: MainMenuProps) {
        super(props);
        this.hasPendingActions = this.hasPendingActions.bind(this);
        this.closePendingModal = this.closePendingModal.bind(this);
        this.goToPendingBalance = this.goToPendingBalance.bind(this);
        this.state = {
            pendingModalIsOpen: false
        }
    }

    componentDidMount() {
        this.hasPendingActions();
    }

    closePendingModal(){
        this.setState({ pendingModalIsOpen: false });
    }

    goToPendingBalance(){
        this.props.history.replace(DEVICES_BALANCE_STOCKTAKING_ROUTE);
    }

    hasPendingActions() : void {
        if(this.props.authUser && this.props.authUser.branchOffice && this.props.authUser.branchOffice.code !== 'CUID' && this.props.authUser.branchOffice.code !== '1')
        {
            findLastOfficeStatus(this.props.authUser.branchOffice.code).then((statusOffice: ReportOfficeStatus[]) => {
                if(this.props.authUser && this.props.authUser.role.codeRole == "SUCSP"){
                    if (statusOffice.length !== 0 && statusOffice[0].pendingApproval){
                        this.setState({ pendingModalIsOpen : true });
                    }
                }
                if(this.props.authUser && this.props.authUser.role.codeRole == "SUCOP"){
                    if (statusOffice.length === 0 || !statusOffice[0].opened || statusOffice[0].closened){
                        //TODO: AÚN NO REALIZA APERTURA
                        //this.props.setMessage({ message: "AÚN NO REALIZA APERTURA", type: MESSAGE_WARNING });
                    }
                }
            });
        }
    }

    render() {
        const customStyles: any = {
            content: {
                top: '30%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                width: '30%'
            }
        };

        const menuItems = this.props.menuItems.map((menuItem: MainMenuItem) => {
            if(this.props.havePermission(...menuItem.permissions)) {
                return (
                    <Link key={menuItem.id} className="col-lg-4 col-md-6 col-sm-6 col-xs-12" id={menuItem.id} to={menuItem.path}>
                        <div className={"card " + menuItem.color + " summary-inline"} >
                            <div className="card-body">
                                <i className={"icon fa " + menuItem.icon + " fa-3x"}></i>
                                <div className="content">
                                    <div className="title">{menuItem.title}</div>
                                    <div className="sub-title">{menuItem.text}</div>
                                </div>
                                <div className="clear-both"></div>
                            </div>
                        </div>
                    </Link>
                )
            } else {
                return <div key={menuItem.id}></div>
            }
        });

        return (
            <>
                <div className="card">
                    <div className="card-body row">{menuItems}</div>
                </div>
                <Modal
                    isOpen={this.state.pendingModalIsOpen}
                    onRequestClose={this.closePendingModal}
                    style={customStyles}
                    ariaHideApp={false}
                >
                    <h2>{i18n.t('balance-close-pending-title')}</h2>
                    <div className="card-body">
                        <p>{i18n.t('balance-close-pending-alert')}</p>
                        <button className="btn btn-info pull-right" onClick={this.goToPendingBalance}>{i18n.t('balance-close-pending-redirect')}</button>
                    </div>
                </Modal>
            </>
        )
    }
}

export const MainMenu = withAppContext(MainMenuMain);